import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import "./App.css";

const Navbar = lazy(() => import( "./Sections/Header"));
const HomeApp = lazy(() => import( './pages/HomeApp'));
const Footer = lazy(() => import( ".//Sections/Footer"));
const About = lazy(() => import( './pages/About'));
const Game = lazy(() => import( './pages/Game'));
const Tétris = lazy(() => import( './pages/Tétris'));
const Mots_Croisés = lazy(() => import( "./pages/mots-croisés/"));
const Connect_4 = lazy(() => import("./pages/Connect-4/"));
const Contact_us = lazy(() => import("./pages/Contact/"));

const   renderLoader = () => 
    <div className="container-loader">
      <h2>Chargement</h2>
        <div class="loader loader-1">
          <div class="loader-outter"></div>
          <div class="loader-inner"></div>
        </div>
    </div>
;

function App() {
  return (
    <Router>
      <Suspense fallback={renderLoader()}>   
        <Navbar />
          <Switch>
            <Route path='/' exact component={HomeApp} />
            <Route path='/Mots-Croisés' component={Mots_Croisés} />
            <Route path='/À-propos' component={About} />
            <Route path='/Game' component={Game} />
            <Route path='/Tétris' component={Tétris} />
            <Route path='/Connect-4' component={Connect_4} />
            <Route path='/Contact-us' component={Contact_us} />
          </Switch>  
        <Footer />
      </Suspense>
    </Router>
  );
}

export default App;

/**const renderLoader = () => <div className="container-loader"><h2>Chargement</h2><img src="images/pong.gif" alt='gif de chargement'/></div>; */